import { render, staticRenderFns } from "./compensation.vue?vue&type=template&id=5c475904&scoped=true"
import script from "./compensation.vue?vue&type=script&lang=js"
export * from "./compensation.vue?vue&type=script&lang=js"
import style0 from "./compensation.vue?vue&type=style&index=0&id=5c475904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c475904",
  null
  
)

export default component.exports